const DATE_SEPARATOR = "-";

export const normalizeAssetFilterDate = (value = "") => {
  const parts = String(value).trim().split(DATE_SEPARATOR);

  if (parts.length !== 3) return "";

  const [day, month, year] = parts;
  if (!day || !month || !year) return "";

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

export const parseAssetFilterDate = (value = "") => {
  const normalized = normalizeAssetFilterDate(value);
  if (!normalized) return null;

  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const validateAssetDateRange = (fromDate, toDate) => {
  if (toDate && !fromDate) return "Vui lòng nhập ngày bắt đầu.";
  if (fromDate && !toDate) return "Vui lòng nhập ngày kết thúc.";

  const from = parseAssetFilterDate(fromDate);
  const to = parseAssetFilterDate(toDate);

  if (fromDate && !from) return "Ngày bắt đầu không hợp lệ.";
  if (toDate && !to) return "Ngày kết thúc không hợp lệ.";
  if (from && to && from > to) return "Ngày bắt đầu không được lớn hơn ngày kết thúc.";

  return "";
};

export const buildAssetDateParams = ({ fromDate, toDate } = {}) => {
  const params = {};
  const normalizedFromDate = normalizeAssetFilterDate(fromDate);
  const normalizedToDate = normalizeAssetFilterDate(toDate);

  if (normalizedFromDate) params.fromDate = normalizedFromDate;
  if (normalizedToDate) params.toDate = normalizedToDate;

  return params;
};

export const buildAssetExportParams = ({ search = "", fromDate, toDate } = {}) => {
  const params = buildAssetDateParams({ fromDate, toDate });
  const keyword = String(search).trim();

  if (keyword) params.search_value = keyword;

  return params;
};
